export default [
  {
    path: "/report-efficiency",
    name: "report-efficiency",
    meta: {
      title: "Отчет по эффективности",
      authRequired: true,
    },
    component: () => import("../views/index.vue"),
  },
];
